import { getLogger } from "@expert/logging";
import { useQuery } from "@tanstack/react-query";
import { getPersonalizeCoverageExamples } from "../api";
import { useContentfulClient } from "../ContentfulClientProvider";

const logger = getLogger({
    module: "personalize-coverage",
    supportTeam: "sales",
});
export const usePersonalizeCoverage = (productSku?: string) => {
    const contentfulClient = useContentfulClient();
    const { data } = useQuery({
        queryKey: ["personalize-coverage", productSku],
        queryFn: async () => await getPersonalizeCoverageExamples(contentfulClient, productSku),
    });
    if (!data) {
        logger.info({ productSku }, "Failed to find personalize coverage examples");
        return [];
    }
    return data;
};
